export enum FileUploadType {
  File = 'file',
  Audio = 'audio',
  Image = 'image',
  Video = 'video'
}

export type FileUploadCardActionsProps = {
  onDelete?: () => void;
  onPreview?: () => void;
  onDownload?: () => void;
  type: string;
};

export type MediaModalProps = {
  type: string;
  selectedItem: any;
  onClose: () => void;
  showDialog: boolean;
};
